<i18n src="@/lang/actions.json"></i18n>

<i18n>
    {
    "en":{
    "Dashboard": "Dashboard",
    "Customers": "Customers",
    "Services": "Services",
    "Widgets": "Widgets",
    "Embedded": "Embedded",
    "Periods": "Periods",
    "Texts": "Texts",
    "TMP": "Temporary"
    },
    "ua":{
    "Dashboard": "Панель",
    "Customers": "Клієнти",
    "Services": "Сервіси",
    "Widgets": "Віджети",
    "Embedded": "Embedded",
    "Periods": "Періоди",
    "Texts": "Тексти",
    "TMP": "Temporary"
    },
    "ru":{
    "Dashboard": "Панель",
    "Customers": "Клиенты",
    "Services": "Сервисы",
    "Widgets": "Виджеты",
    "Embedded": "Embedded",
    "Periods": "Периоды",
    "Texts": "Тексты",
    "TMP": "Temporary"
    }
    }
</i18n>

<template>
  <el-aside width="auto">
    <left-menu :user="user" :items="menuItems" :collapse="isCollapsed" />
  </el-aside>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app_aside",
  computed: {
    ...mapGetters({
      user: "user/user",
      menuItems: "cache/shared_menu/menuItems",
      isCollapsed: "cache/shared_menu/isCollapsed"
    })
  }
};
</script>

<style lang="stylus">
.el-submenu.user > .el-submenu__title
    padding 0 !important

.el-aside .el-menu
    border-right none
</style>

<style scoped lang="stylus">
.el-avatar
    background-color transparent


.el-aside
    color #9da8ae
    background-color #1b3446
    transition all 0.2s
    user-select none
    max-width 210px

.el-header
    display flex
    align-items center
    padding 0
    border-right 1px solid #e8eaeb


.el-menu
    border-right none


.el-menu-item
    background-color #1b3446
    color #9da8ae


/*@media (max-width: 800px)*/
/*    .el-aside*/
/*        width 64px !important*/
/*        transition all 0.2s*/


/*    .el-header span*/
/*        display none*/


/*    li[role='menuitem'] > span*/
/*        display none*/



/*.user*/
/*    .el-menu-item*/
/*        background-color #fff*/
/*        color #333*/
</style>
